import { render, staticRenderFns } from "./getpass.vue?vue&type=template&id=4db81f2a&scoped=true"
import script from "./getpass.vue?vue&type=script&lang=js"
export * from "./getpass.vue?vue&type=script&lang=js"
import style0 from "./getpass.vue?vue&type=style&index=0&id=4db81f2a&prod&lang=scss"
import style1 from "./getpass.vue?vue&type=style&index=1&id=4db81f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db81f2a",
  null
  
)

export default component.exports